import { Brain } from 'lucide-react'
import { InfoTooltip } from '../../components/common/InfoTooltip'
import {
  ChipWrapper,
  ProgressBarTrack,
  ProgressBarFill,
  ThresholdMarker,
} from './NodeQualityChip.styles'
import { NODE_QUALITY_CONFIG } from './config'
import type { QualityScoreResult } from './scoreCalculator'

interface NodeQualityChipProps {
  qualityResult: QualityScoreResult
  nodeCategory: string
  /** Renders inline (relative positioning) instead of absolutely above the node */
  inline?: boolean
}

export function NodeQualityChip({ qualityResult, nodeCategory, inline }: NodeQualityChipProps) {
  const { score, meetsAIThreshold } = qualityResult
  const threshold = NODE_QUALITY_CONFIG[nodeCategory]?.aiThreshold ?? 40

  const tooltipText = meetsAIThreshold
    ? `AI suggestions are active. Keep adding detail for more relevant results.`
    : `Fill in more detail to unlock AI suggestions. The more context you provide, the better they'll be.`

  return (
    <ChipWrapper className="nodrag" $inline={inline}>
      <Brain size={14} color="var(--color-text-secondary)" />
      <ProgressBarTrack>
        <ProgressBarFill $score={score} $meetsThreshold={meetsAIThreshold} />
        <ThresholdMarker $position={threshold} />
      </ProgressBarTrack>
      <InfoTooltip title={tooltipText} placement="top" />
    </ChipWrapper>
  )
}
